import renderMinicart from '../lib/renderMinicart';
import getCart from '../lib/getCart';
import updateCartCount from '../lib/updateCartCount';
import { WISHLIST } from '../utils/constants';

const CART_REQUEST_PATTERN = /\/cart\/(add|change)\.js/;
const HTTP_STATUS_OK_MIN = 200;
const HTTP_STATUS_OK_MAX = 300;

const syncMinicart = async () => {
  // renderMinicart() re-fetches the drawer's own HTML and has no access to
  // item_count itself, so the header badge needs its own cart.js fetch -
  // same as addToCart.js/changeCart.js do after a normal, theme-driven add.
  const [cart] = await Promise.all([getCart(), renderMinicart()]);
  if (cart) updateCartCount(cart.item_count);
  window.theme.minicart?.open();
};

const patchXhrForCartSync = () => {
  if (XMLHttpRequest.prototype.cartSyncPatched) return;
  XMLHttpRequest.prototype.cartSyncPatched = true;

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function open(method, url, ...rest) {
    this.isCartRequest = CART_REQUEST_PATTERN.test(url);
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function send(...args) {
    if (this.isCartRequest) {
      this.addEventListener('loadend', () => {
        if (this.status < HTTP_STATUS_OK_MIN || this.status >= HTTP_STATUS_OK_MAX) return;
        syncMinicart();
      });
    }
    return originalSend.apply(this, args);
  };
};

const initWishlistAtc = () => {
  if (document.body.dataset.wishlistAtcBound === 'true') return;
  document.body.dataset.wishlistAtcBound = 'true';

  document.addEventListener(WISHLIST.ADDED_TO_CART_EVENT, syncMinicart);
  patchXhrForCartSync();
};

export default initWishlistAtc;
